export const Props = () => ({
  //--------------------------------------------------------------------------
  //                  Массив объектов формата ключ/значение
  //--------------------------------------------------------------------------
  list: {
    type: Object,
    required: true
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});